// Design system: Nothing-inspired near-black + signal red, restrained glass.
// Contrast on bgDark #0B0B0D: primary #E02020 4.12 (accents/UI), white on
// primary 4.78 (AA), white on secondary 6.22 (AA), textLight ~16 (AAA-ish).
// Display type Doto (OFL, Google Fonts, variable wght 100-900) is
// Latin-only: it is applied to headings/brand with per-script fallbacks,
// never to body copy.
export const theme = {
    colors: {
        black: '#000000',
        white: '#ffffff',
        primary: '#E02020',
        secondary: '#C1121F',
        success: '#4cc9f0',
        error: '#f72585',
        bgDark: '#0B0B0D',
        bgMedium: '#141417',
        textLight: '#E8E8EA',
        textLighter: 'rgba(232, 232, 234, 0.72)',
        cardBg: 'rgba(20, 20, 23, 0.72)',
        cardBorder: 'rgba(255, 255, 255, 0.12)',
        primaryGlow: 'rgba(224, 32, 32, 0.35)',
    },
// Display type Doto (OFL, Google Fonts, variable wght 100-900): glyphs built
// from dots — the Nothing OS dotted aesthetic. Latin-only: DotGothic16 second
// covers Japanese; ar/ja/zh/hi keep dedicated stacks. Applied to
// headings/brand/display numerals only, never body copy.
    fonts: {
        body: "'Poppins', 'Cairo', 'Noto Sans SC', system-ui, -apple-system, sans-serif",
        display: "'Doto', 'DotGothic16', 'Cairo', 'Noto Sans SC', 'Poppins', system-ui, sans-serif",
        locales: {
            ar: {
                body: "'Cairo', system-ui, -apple-system, sans-serif",
                headings: "'Handjet', 'Cairo', 'Poppins', system-ui, sans-serif",
            },
            ja: {
                body: "'Poppins', system-ui, -apple-system, sans-serif",
                headings: "'DotGothic16', 'Poppins', system-ui, sans-serif",
            },
            zh: {
                body: "'Noto Sans SC', system-ui, -apple-system, sans-serif",
                headings: "'ZCOOL XiaoWei', 'Noto Sans SC', 'Poppins', system-ui, sans-serif",
            },
            hi: {
                body: "'Poppins', 'Yantramanav', system-ui, -apple-system, sans-serif",
                headings: "'Yantramanav', 'Poppins', system-ui, sans-serif",
            },
        },
    },
    ui: {
        cardRadius: '16px',
        cardPadding: 'clamp(1rem, 2.5vw, 1.75rem)',
        navHeight: '60px',
    },
    spacing: {
        xs: '0.5rem',
        sm: '0.75rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem',
    },
    transitions: {
        fast: 'calc(0.2s * var(--motion-duration-scale, 1)) ease',
        medium: 'calc(0.3s * var(--motion-duration-scale, 1)) ease',
    },
    shadows: {
        md: '0 6px 12px rgba(0, 0, 0, 0.2)',
        lg: '0 10px 20px rgba(0, 0, 0, 0.25)',
    }
};
